module.exports = __webpack_public_path__ + "img/logo_monro_black.2ea96f0f.png";